import { Link } from "react-router-dom";
import { Bitcoin, Flame, ShoppingBag, HeartHandshake, ArrowUpRight, Zap } from "lucide-react";

const features = [
  {
    icon: Flame,
    title: "BitDate",
    desc: "Swipe. Match. Meet in real life. A dating layer for the sound-money crowd.",
  },
  {
    icon: ShoppingBag,
    title: "Marketplace",
    desc: "Buy and sell anything, priced in sats. From vintage watches to hardware wallets.",
  },
  {
    icon: HeartHandshake,
    title: "Donations",
    desc: "Fund the platform directly on-chain. Every sat supports the network you love.",
  },
];

export default function Landing() {
  return (
    <main data-testid="landing-page" className="min-h-screen">
      {/* Hero */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <div className="inline-flex items-center gap-2 px-3 py-1 border-2 border-black bg-white font-mono text-xs uppercase tracking-widest mb-8">
              <Zap className="w-3 h-3 text-[#F7931A]" /> Now Open · Bitcoin-native social
            </div>
            <h1 className="font-display font-black uppercase tracking-tighter text-5xl sm:text-7xl lg:text-8xl leading-[0.9]">
              The Facebook
              <br />
              of <span className="text-[#F7931A]">Bitcoin.</span>
              <br />
              <span className="sr-only">Bitbook</span>
            </h1>
            <p className="mt-8 text-lg lg:text-xl max-w-xl leading-relaxed text-[#0A0A0A]/80">
              Bitbook is a social network for people who think in sats. Post to the feed. Match on
              BitDate. Trade in the marketplace. Pay a one-time <span className="font-mono font-bold">0.001 BTC (~$100)</span> to join for life.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <Link
                to="/register"
                data-testid="cta-join"
                className="inline-flex items-center gap-2 px-6 py-4 bg-[#F7931A] border-2 border-black font-bold uppercase tracking-widest btn-brutal"
              >
                Create Account <ArrowUpRight className="w-5 h-5" />
              </Link>
              <Link
                to="/login"
                data-testid="cta-login"
                className="inline-flex items-center gap-2 px-6 py-4 bg-white border-2 border-black font-bold uppercase tracking-widest btn-brutal"
              >
                I'm already in
              </Link>
            </div>
          </div>
          <div className="lg:col-span-4">
            <div className="border-2 border-black bg-[#0A0A0A] text-[#FDFBF7] p-6">
              <div className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-[#F7931A]">
                <Bitcoin className="w-4 h-4" /> Membership
              </div>
              <div className="font-display font-black text-4xl mt-4">One-time fee.</div>
              <div className="font-mono text-lg mt-2">0.001 BTC <span className="text-white/50 text-sm">(~$100)</span></div>
              <div className="text-sm mt-4 text-white/70 leading-relaxed">
                Pay once, join forever. No ads. No data-harvesting. Just people who move in sats.
              </div>
              <div className="mt-6 border-t border-white/20 pt-4 font-mono text-[10px] uppercase tracking-widest text-white/50">
                Verified on-chain via mempool.space
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="border-t-2 border-black" />

      {/* Features */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-2 border-black bg-white">
          {features.map((f, i) => {
            const Icon = f.icon;
            return (
              <div
                key={f.title}
                data-testid={`feature-${f.title.toLowerCase()}`}
                className={`p-8 lg:p-10 ${i > 0 ? "md:border-l-2 border-black" : ""} ${
                  i > 0 ? "border-t-2 md:border-t-0 border-black" : ""
                }`}
              >
                <div className="w-12 h-12 border-2 border-black flex items-center justify-center bg-[#F7931A] mb-6">
                  <Icon className="w-6 h-6 text-black stroke-[2.5]" />
                </div>
                <h3 className="font-display text-2xl font-black uppercase">{f.title}</h3>
                <p className="mt-3 text-[#0A0A0A]/70 leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </section>

      <footer className="border-t-2 border-black py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 font-mono text-xs uppercase tracking-widest">
          <div>© Bitbook · A sound-money social network</div>
          <div className="text-[#0A0A0A]/60">Built on-chain. Not on ads.</div>
        </div>
      </footer>
    </main>
  );
}
